import { render, staticRenderFns } from "./BrokerOrgs.vue?vue&type=template&id=45187e3e&"
import script from "./BrokerOrgs.vue?vue&type=script&lang=js&"
export * from "./BrokerOrgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports